<div #dndPanel class="demo-dnd-panel" role="list" aria-label="Walkthrough nodes; drag the highlighted one onto the model"></div>
